import { z } from "zod";
/**
 * Factory function to create AuthenticateUserValidator with translations
 */
export const createAuthenticateUserValidator = (t) => z.object({
    email: z.email(t("validation.email")),
    password: z.string().min(1, t("validation.required")),
});
